import round from "../number/round";

// converts from mmol/L to mg/dL
export default function cholesterolToImperial(cholesterol, precision = 0) {
  if (cholesterol === undefined) {
    return undefined;
  }
  return round(cholesterol * 38.67, precision);
}
